import { Directive, ElementRef, Input, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appHighlightMissing]'
})
export class HighlightMissingDirective implements OnChanges {
  @Input('appHighlightMissing') value: any;
  @Input() highlightClass = 'campo-nao-informado'; // Permite customizar a classe
  readonly NAO_INFORMADO = 'Não informado';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.updateHighlight();
    }
  }

  private updateHighlight(): void {
    if (this.value === this.NAO_INFORMADO) {
      this.renderer.addClass(this.el.nativeElement, this.highlightClass);
    } else {
      this.renderer.removeClass(this.el.nativeElement, this.highlightClass);
    }
  }
}